/**
 * GraphQL Client configuration
 * Uses graphql-request for simple, lightweight GraphQL queries
 */

import { GraphQLClient } from 'graphql-request';

// Detect environment based on hostname
const isLocalhost = typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' ||
   window.location.hostname === '127.0.0.1' ||
   window.location.hostname === '0.0.0.0');

const GRAPHQL_ENDPOINT = isLocalhost
  ? 'http://localhost:8787/graphql'
  : 'https://monorepo-dashboard-api.finhub.workers.dev/graphql';

export const graphqlClient = new GraphQLClient(GRAPHQL_ENDPOINT, {
  headers: {
    'Content-Type': 'application/json',
  },
});
